import { render, staticRenderFns } from "./sarmadGantt.vue?vue&type=template&id=67e18907&"
import script from "./sarmadGantt.vue?vue&type=script&lang=js&"
export * from "./sarmadGantt.vue?vue&type=script&lang=js&"
import style0 from "./sarmadGantt.vue?vue&type=style&index=0&id=67e18907&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports